
import { useState, useEffect } from 'react';
import { LocationOption } from '@/types/weather';
import { toast } from '@/hooks/use-toast';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<LocationOption[]>([]);

  // Load favorites from localStorage on mount
  useEffect(() => {
    try {
      const storedFavorites = localStorage.getItem('favoriteLocations');
      if (storedFavorites) {
        setFavorites(JSON.parse(storedFavorites));
      }
    } catch (error) {
      console.error('Error loading favorites:', error);
    }
  }, []);

  // Save favorites to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem('favoriteLocations', JSON.stringify(favorites));
    } catch (error) {
      console.error('Error saving favorites:', error);
    }
  }, [favorites]);

  const toggleFavorite = (location: LocationOption) => {
    setFavorites(prevFavorites => {
      const isAlreadyFavorite = prevFavorites.some(fav => fav.id === location.id);
      
      if (isAlreadyFavorite) {
        toast({
          title: "Removed from favorites",
          description: `${location.name} has been removed from your favorites`
        });
        return prevFavorites.filter(fav => fav.id !== location.id);
      } else {
        toast({
          title: "Added to favorites",
          description: `${location.name} has been added to your favorites`
        });
        return [...prevFavorites, location];
      }
    });
  };

  const isFavorite = (location: LocationOption) => {
    return favorites.some(fav => fav.id === location.id);
  };

  return { favorites, toggleFavorite, isFavorite };
};
